import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  accessToken: null,
  isAuth: false,
  permissions: [],
};

export const AuthSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setAccessToken: (state, action) => {
      const { accessToken } = action.payload;
      state.accessToken = accessToken;
    },
    setPermissions: (state, action) => {
      const { permissions } = action.payload;
      state.permissions = permissions;
    },
    removeAccessToken: (state, action) => {
      state.accessToken = null;
    },
    setIsAuth: (state, action) => {
      const { isAuth } = action.payload;
      state.isAuth = isAuth;
    },
  }
})

export const { setAccessToken, setPermissions, setIsAuth, removeAccessToken } = AuthSlice.actions;

export default AuthSlice.reducer;